import React from 'react'
import Link from 'components/shared/Link'
import classnames from 'classnames/bind'
import tweetIcon from './tweet-icon.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const TweetTextButton = ({ className, href, text, top }) => {
  return (
    <Link
      style={{ top: `${top  }px` }}
      className={cx(className, css.TweetButton, { visible: text })}
      href={href}
      target="_blank"
    >
      <img src={tweetIcon} alt="tweet selection" />
    </Link>
  )
}

TweetTextButton.defaultProps = {}

export default TweetTextButton
